<template>
  <el-container style="height: 100%">
    <el-header
      style="
        height: 60px;
        background-color: blue;
        padding-top: 35px;
        color: white;
      "
    >
      <el-row>
        <el-col :span="8" style="text-align: left"> 《 </el-col>        
      </el-row>
    </el-header>
    <el-main style="flex: 1">
      <el-row>
        <el-col :span="24">
            预约日期:
            <el-date-picker
            v-model="value"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          预约时间
        </el-col>
        <el-col :span="12" text-align="right">
          剩余名额
        </el-col>
      </el-row>

      
          上午<br/>
          <el-row >
              <el-col :span="8" v-for="interval in am" :label="interval" :key="interval">
                <el-button type="primary" plain size="mini">{{interval}}</el-button>
              </el-col>
          </el-row>
          
      
      下午<br/>
          <el-row >
              <el-col :span="8" v-for="interval in pm" :label="interval" :key="interval">
                <el-button type="primary" plain size="mini">{{interval}}</el-button>
              </el-col>
          </el-row>
      地址检测
        <el-input></el-input>
        <el-button type="primary" style="width:100%;margin-top:10px" @click="nextStep">确认预约</el-button>
    </el-main>
  </el-container>
</template>

<script type="text/ecmascript-6">
const am = ['09:00 - 09:30', '09:30 - 10:00', '10:00 - 10:30', '10:30 - 11:00','11:00 - 11:30','11:30 - 12:00'];
const pm = ['13:00 - 13:30', '13:30 - 14:00', '14:00 - 14:30', '14:30 - 15:00','15:00 - 15:30','15:30 - 16:00']
export default {
  name: "login",
  data() {
    return {
      value:new Date(),
      checkboxGroup1: ['09:00 - 09:30'],
      am: am,
      pm: pm,
    };
  },
  // 创建完毕状态(里面是操作)
  created() {},
  // 里面的函数只有调用才会执行
  methods: {
    nextStep() {
      this.$router.push({ path: "/appIndex/appointmentResult" });
    },
  },
};
</script>

<style lang=less scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
</style>